export default __webpack_public_path__ + "static/media/notAuthenticated.983b8e4b.svg";